import React, { Component } from "react";
import "./HSGTabs.css";
import downarrow from "../../DashboardContainer/Component/NewUiimg/downarrow.png";
class Tabs extends Component {
  update = (index, nav, label, e) => {
    if (e) {
      e.preventDefault();
    }
    this.props.changeTab(index, nav);
  };

  getLabels = (child, index) => {
    let { nav, label } = child.props;
    var activeClass = this.props.selected === nav ? "-selected" : "";

    return (
      <div
        key={index}
        className={"hsg-tab" + activeClass}
        style={{ color: "#1E87F0", fontFamily: "Montserrat" }}
      >
        <div onClick={() => this.update(index, nav, label)}>
          {child.props.label ? child.props.label.toUpperCase() : ""}
        </div>
        {child.props.badge !== 0 &&
          child.props.badge !== undefined &&
          activeClass !== "-selected" && (
            <span className="hsg-badge">{child.props.badge}</span>
          )}
      </div>
    );
  };

  getDropdownOptions = (child, index) => {
    let { nav, label } = child.props;
    return (
      <li
        key={index}
        style={{ padding: "0px 5px", alignItems: "center", cursor: "pointer" }}
        className="dropdown-item"
        onClick={() => this.update(index, nav, label)}
      >
        {child.props.label ? child.props.label.toUpperCase() : ""}
      </li>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="foryearadjust  ">
          <div className="tab-bottom">
            <div className="dropdown removefocus">
              <button
                className="btn dateadjust "
                style={{
                  margin: "0px",
                  padding: "5px 0px 10px 0px",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",

                  // justifyContent: "flex-end",
                }}
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <text className="datebadgefont" style={{ color: "#1E87F0" }}>
                  {this.props.children ? (
                    this.props.children.find(
                      (child) => child.props.nav === this.props.selected,
                    ) ? (
                      <>
                        {
                          this.props.children.find(
                            (child) => child.props.nav === this.props.selected,
                          ).props.label
                        }
                        <img className="downarrowyear" src={downarrow} />
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </text>
              </button>
              <ul className="dropdown-menu" style={{ margin: "0px" }}>
                <li>
                  <ul>
                    <text>
                      {this.props.children
                        ? this.props.children
                            ?.filter(
                              (child) =>
                                child.props.nav !== this.props.selected,
                            )
                            ?.map(this.getDropdownOptions)
                        : ""}
                    </text>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Tabs;

Tabs.defaultProps = {
  selected: "school",
};
